// recon-tax-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rcs.payStatus.notApplicable': 'Ikke aktuelt',
  'rcs.payStatus.paidLate': 'Betalt etter frist',
  'rcs.payStatus.paidAfterPeriod': 'Betalt etter periodeslutt',
  'rcs.payStatus.paid': 'Betalt',
  'rcs.payStatus.partial': 'Delvis betalt',
  'rcs.payStatus.overdue': 'Forfalt — ikke betalt',
  'rcs.payStatus.notDue': 'Ikke forfalt',
  'rcs.payStatus.noFee': 'Ingen avgift i perioden',
  'rcs.bookStatus.notBooked': 'Ikke bokført',
  'rcs.bookStatus.booked': 'Bokført',
  'rcs.bookStatus.difference': 'Bokføringsdifferanse',
  'rcs.bookStatus.ownTerm': 'Avstemt i egen termin',
  'rcs.bookStatus.onSubmit': 'Gjøres opp ved innsending',
  'rcs.claimStatus.payrollRun': 'Beregnet av lønnskjøringen',
  'rcs.claimStatus.payrollSystem': 'Beregnet av lønnssystemet',
  'rcs.claimStatus.fixed': 'Fastsatt ved innsending',
  'rcs.claimStatus.notFixed': 'Ikke fastsatt',
  'rcs.reported.withholdingYes': 'Meldt i A-melding',
  'rcs.reported.withholdingNo': 'Ikke registrert meldt',
  'rcs.reported.vatSubmitted': 'Levert MVA-melding',
  'rcs.reported.vatDraft': 'Utkast — ikke sendt',
  'rcs.claim.withholdingTitle': 'Forskuddstrekk – {label}',
  'rcs.claim.runPeriod': 'lønn {period}',
  'rcs.claim.runDate': 'kjøring {date}',
  'rcs.claim.agaTitle': 'Arbeidsgiveravgift – {term}. termin',
  'rcs.claim.agaPeriod': '{term}. termin {year}',
  'rcs.claim.vatTitle': 'Merverdiavgift – {n}. termin',
  'rcs.payment.description': 'Betaling {title}',
  'rcs.payment.directPosting': 'Postering på kontrollkonto',
  'rcs.vat.noTerm': 'Ingen termin funnet',
  'rcs.source.ledger': 'Hovedbok',
  'rcs.source.payroll': 'Lønnskjøringer',
  'rcs.source.amelding': 'A-melding',
  'rcs.source.vat': 'MVA-melding for terminen',
  'rcs.source.payments': 'Registrerte betalinger av skatt og avgift',
  'rcs.source.bank': 'Bankutskrift for betalingene',
  'rcs.source.skatteetaten': 'Kravoversikt og saldo fra Skatteetaten',
  'rcs.source.ledgerDetail': '{count} posteringer på kontrollkontoene i perioden',
  'rcs.source.payrollDetailOne': '{count} bokført kjøring i perioden',
  'rcs.source.payrollDetailMany': '{count} bokførte kjøringer i perioden',
  'rcs.source.payrollDetailNone': 'Ingen bokførte lønnskjøringer i perioden',
  'rcs.source.ameldingNone': 'Ingen kjøringer å melde',
  'rcs.source.ameldingDetail': '{reported} av {total} kjøringer er registrert som meldt',
  'rcs.source.vatDetail': '{period} {year} · frist {due}',
  'rcs.source.paymentsDetail': '{count} krav har registrert betaling',
  'rcs.source.bankNone': 'Ingen bankutskrift dekker perioden — betalingene kan ikke bekreftes mot banken',
  'rcs.source.bankDetail': '{covered} av {total} registrerte betalinger er matchet mot en banklinje',
  'rcs.source.skatteetatenDetail': 'Plumme henter ikke krav, KID eller kontoutskrift fra Skatteetaten. Kravene under er foretakets egne beregnede forpliktelser med lovbestemt forfall.',
  'rcs.check.accounts': 'Alle relevante kontrollkontoer er inkludert',
  'rcs.check.balance': 'Bokført saldo er sammenlignet med beregnede krav',
  'rcs.check.withholdingPayroll': 'Forskuddstrekk er sammenlignet med lønn og A-melding',
  'rcs.check.withholdingPayments': 'Forskuddstrekk er kontrollert mot registrerte betalinger',
  'rcs.check.withholdingDeadlines': 'Betalingsfrister for forskuddstrekk er kontrollert',
  'rcs.check.aga': 'Arbeidsgiveravgift stemmer med lønnssystemets grunnlag',
  'rcs.check.agaDeadline': 'Arbeidsgiveravgiftens betalingsfrist er kontrollert',
  'rcs.check.vat': 'MVA-oppgjøret er koblet til MVA-avstemmingen',
  'rcs.check.partial': 'Delbetalte krav er identifisert',
  'rcs.check.bankCoverage': 'Registrerte betalinger er bekreftet mot bankutskriften',
  'rcs.check.bankCoverageNone': 'Registrerte betalinger er bekreftet mot bankutskriften (ingen bankutskrift dekker perioden)',
  'rcs.check.direct': 'Direkteføringer på kontrollkontoer er identifisert',
  'rcs.check.overdue': 'Forfalte offentlige krav er identifisert',
  'rcs.check.unbooked': 'Alle krav er bokført som gjeld',
  'rcs.check.payrollBooked': 'Alle lønnskjøringer i perioden er bokført',
  'rcs.role.withholding': 'Ubetalt forskuddstrekk ved periodeslutt',
  'rcs.role.garnishment': 'Utleggstrekk beregnes ikke av lønnsmodellen',
  'rcs.role.aga': 'Påløpt arbeidsgiveravgift som ikke er betalt',
  'rcs.role.agaAccrued': 'Påløpt avgift av feriepenger — avstemmes i lønn',
  'rcs.role.vatSettlement': 'Levert MVA-melding som ikke er gjort opp',
  'rcs.role.taxPayable': 'Regnskapsmessig avsetning — ingen ekstern kilde',
  'rcs.role.deferredTax': 'Regnskapsmessig beregning — ingen ekstern kilde',
  'rcs.role.advanceTax': 'Melding om forskudd hentes ikke av appen',
  'rcs.role.publicFees': 'Andre offentlige avgifter — ingen ekstern kilde',
  'rcs.role.addedByFirm': 'Lagt til skatteområdet av byrået',
});
